import { render, staticRenderFns } from "./EstimatesOldPageSection.vue?vue&type=template&id=c4381bda&"
import script from "./EstimatesOldPageSection.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports